import _memoize from 'lodash/memoize';
import { makeThemeColor, PRIMARY, TERTIARY } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import {
  BORDER_RADIUS,
  BORDER_WIDTH,
  SCALE_FOCUSED,
  FOCUSED_BORDER_ALPHA,
  UNFOCUSED_BORDER_ALPHA,
} from '../utils/focus';
import { cacheResolver, FOCUSED_Z_INDEX, makeDefaultStylingContext, UNFOCUSED_Z_INDEX } from '../utils/style';
import { TRANSPARENT } from '../utils/colors';
import { sizes, templates, INNER_BORDER_COLOR } from './flatRectangle.constants';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  title: makeThemeColor(PRIMARY),
  shadowColor: makeThemeColor(TERTIARY),
  border: makeThemeColor(PRIMARY),
  innerBorder: INNER_BORDER_COLOR,
};

export const TITLE_MARGIN = {
  [HD]: 12,
  [FULL_HD]: 16,
};

export const TITLE_HEIGHT = {
  [HD]: 30,
  [FULL_HD]: 36,
};

export const SHADOW_OFFSET_X = 2;
export const SHADOW_OFFSET_Y = 2;

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => {
  const width = sizes[templates.FlatRectangle][RENDERING_CONTEXT.GENERAL][screenSize].w;
  const height = sizes[templates.FlatRectangle][RENDERING_CONTEXT.GENERAL][screenSize].h;
  const titleWidth = Math.floor(width - TITLE_MARGIN[screenSize] * 2);
  const titleMarginTop = Math.floor(height / 2 - TITLE_HEIGHT[screenSize] / 2);
  const offset = BORDER_WIDTH[screenSize] * 2;

  return {
    zIndex: UNFOCUSED_Z_INDEX,
    w: width,
    h: height,
    Border: {
      alpha: 0,
      x: -BORDER_WIDTH[screenSize],
      y: -BORDER_WIDTH[screenSize],
      w: width + offset,
      h: height + offset,
      shader: {
        outline: BORDER_WIDTH[screenSize],
        radius: BORDER_RADIUS[screenSize],
        strokeColor: TRANSPARENT,
      },
    },
    Image: {
      w: width,
      h: height,
      shader: {
        radius: BORDER_RADIUS[screenSize],
      },
    },
    Title: {
      w: titleWidth,
      x: TITLE_MARGIN[screenSize],
      y: titleMarginTop,
      text: {
        ...getFont(FONT.OTTAWA_2, screenSize),
        textColor: colors.title[colorMode],
        textAlign: 'center',
        maxLines: 1,
        maxLinesSuffix: '...',
        verticalAlign: 'middle',
        shadow: true,
        shadowColor: colors.shadowColor[colorMode],
        shadowOffsetX: SHADOW_OFFSET_X,
        shadowOffsetY: SHADOW_OFFSET_Y,
      },
    },
  };
};

export const getFocusedStyle = _memoize(
  ({ colorMode }) => ({
    zIndex: FOCUSED_Z_INDEX,
    Border: {
      smooth: {
        alpha: FOCUSED_BORDER_ALPHA,
        scale: SCALE_FOCUSED,
        'shader.strokeColor': colors.border[colorMode],
        'shader.innerColor': colors.innerBorder[colorMode],
        'shader.scale': SCALE_FOCUSED,
      },
    },
    Image: {
      smooth: {
        scale: SCALE_FOCUSED,
        'shader.scale': SCALE_FOCUSED,
      },
    },
  }),
  cacheResolver,
);

export const unFocusedStyle = {
  zIndex: UNFOCUSED_Z_INDEX,
  Border: {
    smooth: {
      alpha: UNFOCUSED_BORDER_ALPHA,
      scale: 1,
      'shader.strokeColor': TRANSPARENT,
      'shader.innerColor': TRANSPARENT,
      'shader.scale': 1.0,
    },
  },
  Image: {
    smooth: {
      scale: 1,
      'shader.scale': 1.0,
    },
  },
};
